module.exports = __webpack_public_path__ + "static/img/6293_phase_function_Paper_Points.be2f685.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6293_phase_function_Paper_Points.png
// module id = emj1
// module chunks = 0